/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig"; // Asegúrate de importar correctamente tu instancia de Axios.
import { calculateAge, formatDate, formatMoney } from "../utils/utils";
import GdTable from "./components/GdTable";
import { useNavigate } from "react-router-dom";
import BitacoraPacienteModal from "./BitacoraPacienteModal";
import ModalRecordatoriosPaciente from "./components/ModalRecordatoriosPaciente";
import FormPacienteInicial from "./forms/EditarPaciente";


const DetallePaciente = ({ isOpen, onClose, details }) => {
    const columns2 = [
        { name: "idAcuerdo", title: "ID" },
        { name: 'fechaInicio', title: 'Fecha Inicio', render: (row) => formatDate(row.fechaInicio) },
        { name: 'horaInicio', title: 'Hora inicio' },
        { name: 'horaFin', title: 'Hora fin' },
        { name: 'nombre_auxiliar', title: 'Nombre auxiliar' },
        { name: 'apellido_paterno_auxiliar', title: 'Apellido paterno auxiliar' },
        { name: 'apellido_materno_auxiliar', title: 'Apellido materno auxiliar' },
        { name: 'rut_auxiliar', title: 'RUT auxiliar' }
    ]
    if (!isOpen) return null;
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <h3>Historial de acuerdos mutuos</h3>
                        {details ? (
                            <GdTable
                                columns={columns2}
                                data={details}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[0, "asc"]}
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const BitacoraModal = ({ isOpen, onClose, pacienteID }) => {
    if (!isOpen) return null;
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <h3>Bitacora Paciente</h3>
                        <BitacoraPacienteModal
                            pacienteId={pacienteID}
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RetirarPaciente = ({ isOpen, onClose, onConfirm, paciente }) => {
    const [motivo, setMotivo] = useState("");
    const [fechaRetiro, setFechaRetiro] = useState(new Date().toISOString().split('T')[0]);
    const [periodoRetiro, setPeriodoRetiro] = useState("dia");
    const [observacion, setObservacion] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!motivo) {
            gdAlertify.notiError("Por favor seleccione un motivo");
            return;
        }

        setIsSubmitting(true);

        try {
            const retiroData = {
                pacienteId: paciente.id,
                motivo,
                fechaRetiro,
                turno: periodoRetiro,
                observacion
            };

            // Reemplaza con tu endpoint correcto
            await axiosInstance.post('/paciente/retirar', retiroData);

            // onConfirm(window.location.reload()); // Puedes pasar los datos al callback si es necesario
            onClose(); // Cierra el modal después del éxito

            // Resetear el formulario
            setMotivo("");
            setFechaRetiro(new Date().toISOString().split('T')[0]);
            setObservacion("");
            gdAlertify.alertSuccess("Paciente Retirado.");
        } catch (error) {
            console.error("Error al retirar paciente:", error);
            gdAlertify.notiError("Ocurrió un error al retirar al paciente.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const onCloseRetiro = () => {
        onClose();
        setMotivo("");
        setFechaRetiro(new Date().toISOString().split('T')[0]);
        setObservacion("");
    };

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="retirarPacienteModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Retirar Paciente</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>¿Estás seguro de que deseas retirar al paciente <strong>{paciente?.nombres} {paciente?.apellidoPaterno}</strong>?</p>

                        <div className="mb-3">
                            <label className="form-label">Motivo del retiro:</label>
                            <select
                                className="form-select"
                                value={motivo}
                                onChange={(e) => setMotivo(e.target.value)}
                                required
                            >
                                <option value="">Seleccione un motivo</option>
                                <option value="Alta médica">Alta médica</option>
                                <option value="Fallecimiento">Fallecimiento</option>
                                <option value="Traslado">Traslado</option>
                                <option value="Otro">Otro</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Fecha de retiro:</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaRetiro}
                                onChange={(e) => setFechaRetiro(e.target.value)}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Desde periodo (Turno):</label>
                            <select
                                className="form-select"
                                value={periodoRetiro}
                                onChange={(e) => setPeriodoRetiro(e.target.value)}
                                required
                            >
                                <option value="dia">Día (Mañana/Tarde)</option>
                                <option value="noche">Noche</option>
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Observación (opcional):</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={observacion}
                                onChange={(e) => setObservacion(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onCloseRetiro}
                            disabled={isSubmitting}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Enviando...' : 'Confirmar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const NominaPacienteFinanciero = () => {
    const [resultados, setResultados] = useState([]); // Estado para almacenar los Paciente obtenidos.
    const [selectedPaciente, setSelectedPaciente] = useState(null);
    const [history, setHistory] = useState({}); // Estado para almacenar los historiales de los Paciente.
    const [bitacoraPaciente, setBitacoraPaciente] = useState(false);
    const [pacienteSeleccionadoId, setPacienteSeleccionadoId] = useState(null);
    // Estados para el modal de recordatorios
    const [pacienteRecordatorio, setPacienteRecordatorio] = useState(null);
    const [isRecordatoriosOpen, setIsRecordatoriosOpen] = useState(false);
    
    // Modal Editar
    const [isEditarModalOpen, setIsEditarModalOpen] = useState(false);
    const [pacienteEditarId, setPacienteEditarId] = useState(null);

    const buscarPaciente = async () => {
        gdAlertify.showLoader()
        try {
            const params = {};
            // Realiza la llamada a la API para obtener los Paciente.
            const response = await axiosInstance.get("/paciente/busqueda", { params });
            setResultados(response.data.data); // Almacena los resultados en el estado.
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error("Error al buscar Paciente: ", error);
        }
    };

    useEffect(() => {
        buscarPaciente();
    }, []);

    const handleViewHistory = async (PacienteID) => {
        try {
            // Llamada a la API para obtener el historial de un Paciente específico.
            const response = await axiosInstance.get(`/Paciente/${PacienteID}/historial`);
            setHistory((prev) => ({ ...prev, [PacienteID]: response.data.data }));
            setSelectedPaciente(PacienteID);
        } catch (error) {
            console.error("Error al obtener el historial del Paciente: ", error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalRetiroOpen, setIsModalRetiroOpen] = useState(false);
    const [detallePaciente, setDetallePaciente] = useState(null);

    const verHistorial = async (idPaciente) => {
        setIsModalOpen(true); // Abre el modal
        setDetallePaciente(null); // Limpia los datos previos mientras carga

        const params = {
            idPaciente: idPaciente
        };

        try {
            const response = await axiosInstance.get("/paciente/historial", { params });
            setDetallePaciente(response.data.data);
        } catch (error) {
            console.error(error);
            setDetallePaciente({ error: "No se pudo cargar la información" });
        }
    };

    const retirarPaciente = async (idPaciente) => {
        setIsModalRetiroOpen(true);
        setDetallePaciente({ id: idPaciente });
    };

    const activarPaciente = (pacienteId) => {
        gdAlertify.confirm({
            title: "Activar Paciente",
            message: "¿Está seguro que desea activar nuevamente a este paciente?",
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const response = await axiosInstance.post("/paciente/activar", { pacienteId });
                    if (!response.data.error) {
                        gdAlertify.alertSuccess(response.data.message || "Paciente activado correctamente");
                        buscarPaciente(); // Recargar la lista
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                } catch (error) {
                    console.error("Error al activar paciente:", error);
                    gdAlertify.notiError("Ocurrió un error al activar al paciente.");
                } finally {
                    gdAlertify.hideLoader();
                }
            }
        });
    };

    const navigate = useNavigate();
    const editarPaciente = (idPaciente) => {
        navigate(`/editar-paciente/${idPaciente}`);
    };

    const handleEditarVentana = (idPaciente) => {
        setPacienteEditarId(idPaciente);
        setIsEditarModalOpen(true);
    };

    const abrirRecordatorios = (paciente) => {
        setPacienteRecordatorio(paciente);
        setIsRecordatoriosOpen(true);
    };

    const getTutor = (tutores, tipo) => {
        return tutores?.find(t => t.tipo_tutor === tipo) ||
            tutores?.find(t => t.tipo_tutor === 3) || null;
    };

    const columns = [
        {
            name: "id",
            title: "Acción",
            width: 100,
            render: (row) => {
                return (
                    <div className="dropdown">
                        <button
                            className="btn btn-sm btn-primary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Acciones
                        </button>
                        <ul className="dropdown-menu">
                            {/* Editar */}
                            <li>
                                <button
                                    className="dropdown-item text-success"
                                    onClick={() => editarPaciente(row.id)}
                                >
                                    <i className="bi bi-pencil-square me-2"></i>
                                    Editar
                                </button>
                            </li>

                            {/* Ver Ingresos */}
                            <li>
                                <button
                                    className="dropdown-item text-primary"
                                    onClick={() => {
                                        setPacienteSeleccionadoId(row.id);
                                        setBitacoraPaciente(true);
                                    }}
                                >
                                    <i className="bi bi-journal-text me-2"></i>
                                    Ver Ingresos
                                </button>
                            </li>

                            {/* Ver Historial */}
                            <li>
                                <button
                                    className="dropdown-item text-secondary"
                                    onClick={() => verHistorial(row.id)}
                                >
                                    <i className="bi bi-clock-history me-2"></i>
                                    Ver Historial
                                </button>
                            </li>

                            {/* Recordatorios */}
                            <li>
                                <button
                                    className="dropdown-item text-info"
                                    onClick={() => abrirRecordatorios(row)}
                                >
                                    <i className="bi bi-bell me-2"></i>
                                    Recordatorios
                                </button>
                            </li>

                            {/* Retirar */}
                            {row.estado !== 0 && (
                                <li>
                                    <button
                                        className="dropdown-item text-danger"
                                        onClick={() => retirarPaciente(row.id)}
                                    >
                                        <i className="bi bi-person-x me-2"></i>
                                        Retirar
                                    </button>
                                </li>
                            )}

                            {/* Activar */}
                            {row.estado === 0 && (
                                <li>
                                    <button
                                        className="dropdown-item text-primary"
                                        onClick={() => activarPaciente(row.id)}
                                    >
                                        <i className="bi bi-person-check me-2"></i>
                                        Activar
                                    </button>
                                </li>
                            )}

                            {/* Editar (ventana) */}
                            <li>
                                <button
                                    className="dropdown-item text-warning"
                                    onClick={() => handleEditarVentana(row.id)}
                                >
                                    <i className="bi bi-window me-2"></i>
                                    Editar (ventana)
                                </button>
                            </li>
                        </ul>
                    </div>
                );
            },
        },
        { name: "nombrePaciente", title: "Nombre y Apellidos", width: 250 },
        { name: "rut", title: "Rut" },
        { name: 'fechaNacimiento', title: 'Edad', render: (row) => calculateAge(row.fechaNacimiento) },
        {
            name: "sexo",
            title: "Sexo",
            render: (row) => row.sexo == '1' ? "Masculino" : row.sexo == '2' ? "Femenino" : "-"
        },
        { name: "fecha_ingreso_sk", title: "Fecha Ingreso SK", render: (row) => formatDate(row.fecha_ingreso_sk) || "-" },
        { name: "direccion", title: "Direccion" },
        { name: "como_llegar", title: "Como llegar" },
        { name: "desc_comuna", title: "Comuna" },
        {
            name: 'fechaInicio',
            title: 'Fecha Inicio',
            render: (row) => row.turnos?.hora_inicio || '-'
        },
        { name: "fecha_ultima_atencion", title: "Última Atención" },
        { name: "valorTurnoPaciente", title: "Valor Turno", render: (row) => '$' + formatMoney(row.valorTurnoAuxiliar) },
        { name: "valorLocomocionPaciente", title: "Locomoción", render: (row) => '$' + formatMoney(row.valorLocomocionAuxiliar) },
        { name: "valorColacionPaciente", title: "Colación", render: (row) => '$' + formatMoney(row.valorColacionAuxiliar) },
        {
            name: "estado",
            title: "Estado",
            width: 250,
            render: (row) => {
                if (row.estado === 1) {
                    return <span className="text-success">Activo</span>;
                } else {
                    const tieneObservacion =
                        row.observacion &&
                        row.observacion.trim() !== "";

                    return (
                        <div className="text-danger">
                            <div><strong>Motivo:</strong> {row.motivo_retiro || '-'}</div>
                            <div><strong>Fecha:</strong> {formatDate(row.fecha_retiro) || '-'}</div>

                            {tieneObservacion && (
                                <div><strong>Obs.:</strong> {row.observacion}</div>
                            )}
                        </div>
                    );
                }
            }
        },

        // Tutor Pago
        {
            name: "tutorPagoNombre",
            title: "Nombre Tutor Pago",
            render: (row) => {
                const tutor = getTutor(row.tutores, 1);
                return tutor ? `${tutor.nombres} ${tutor.apellidoPaterno} ${tutor.apellidoMaterno}` : '-';
            }
        },
        {
            name: "tutorPagoRelacion",
            title: "Relación Tutor Pago",
            render: (row) => {
                const tutor = getTutor(row.tutores, 1);
                return tutor?.relacion || '-';
            }
        },
        {
            name: "tutorPagoCorreo",
            title: "Mail Tutor Pago",
            render: (row) => {
                const tutor = getTutor(row.tutores, 1);
                return tutor?.correo || '-';
            }
        },
        {
            name: "tutorPagoCelular",
            title: "Cel Tutor Pago",
            render: (row) => {
                const tutor = getTutor(row.tutores, 1);
                return tutor?.celular || '-';
            }
        },

        // Tutor Salud
        {
            name: "tutorSaludNombre",
            title: "Nombre Tutor Salud",
            render: (row) => {
                const tutor = getTutor(row.tutores, 2);
                return tutor ? `${tutor.nombres} ${tutor.apellidoPaterno} ${tutor.apellidoMaterno}` : '-';
            }
        },
        {
            name: "tutorSaludRelacion",
            title: "Relación Tutor Salud",
            render: (row) => {
                const tutor = getTutor(row.tutores, 2);
                return tutor?.relacion || '-';
            }
        },
        {
            name: "tutorSaludCorreo",
            title: "Mail Tutor Salud",
            render: (row) => {
                const tutor = getTutor(row.tutores, 2);
                return tutor?.correo || '-';
            }
        },
        {
            name: "tutorSaludCelular",
            title: "Cel Tutor Salud",
            render: (row) => {
                const tutor = getTutor(row.tutores, 2);
                return tutor?.celular || '-';
            }
        },

        // Notas Factura
        {
            name: "notasFactura",
            title: "Notas Factura",
            render: (row) => row.datosFacturacion?.[0]?.notas || '-'
        },

    ];

    return (
        <div className="container-fluid mt-5">
            <div className="card p-4">
                <h3 className="mb-4">Listado de Pacientes</h3>
                {/* Tabla principal */}
                <GdTable
                    columns={columns}
                    data={resultados}
                    defaultItemsPerPage={100}
                    itemsPerPageOptions={[5, 10, 25, 50, 100]}
                    initialSort={[1, "asc"]}
                />
            </div>
            {/* Modal */}
            <DetallePaciente
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                details={detallePaciente}
            />

            {bitacoraPaciente && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <BitacoraPacienteModal
                        pacienteId={pacienteSeleccionadoId}
                        onClose={() => setBitacoraPaciente(false)}
                    />
                </div>
            )}

            <RetirarPaciente
                isOpen={isModalRetiroOpen}
                onClose={() => setIsModalRetiroOpen(false)}
                paciente={detallePaciente}
            />

            <ModalRecordatoriosPaciente
                isOpen={isRecordatoriosOpen}
                onClose={() => setIsRecordatoriosOpen(false)}
                pacienteId={pacienteRecordatorio?.id}
                pacienteNombre={pacienteRecordatorio ? `${pacienteRecordatorio.nombres} ${pacienteRecordatorio.apellidoPaterno}` : ""}
            />

            {/* Modal Editar (Ventana) */}
            {isEditarModalOpen && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Editar Paciente</h5>
                                <button type="button" className="btn-close" onClick={() => setIsEditarModalOpen(false)}></button>
                            </div>
                            <div className="modal-body">
                                <FormPacienteInicial
                                    id={pacienteEditarId}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setIsEditarModalOpen(false)}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default NominaPacienteFinanciero;